import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Select, { SelectOption } from "@amzn/meridian/select";
import AdminContext from "../../store/admin-context";
import { BUSINESS_SPACE_OPTIONS, BUSINESS_SPACE_DROPDOWN_PLACEHOLDER } from "../../constants";

export default function BusinessSpaceSelect({ width = 200, label = "" }) {
  const { selectedBusinessSpace, changeSelectedBusinessSpace, selectedNode } = useContext(AdminContext);
  const history = useHistory();

  function onChangeBusinessSpaceHandler(value) {
    changeSelectedBusinessSpace(value);
    const path = selectedNode ? `/${value}/${selectedNode}` : `/${value}`;
    history.push(path);
  }

  return (
    <Select
      data-testid="businessSpaceSelect"
      value={selectedBusinessSpace}
      onChange={onChangeBusinessSpaceHandler}
      placeholder={BUSINESS_SPACE_DROPDOWN_PLACEHOLDER}
      width={width}
      label={label}
    >
      {BUSINESS_SPACE_OPTIONS.map((businessSpace) => (
        <SelectOption
          data-testid="businessSpaceSelectOption"
          key={businessSpace}
          value={businessSpace}
          label={businessSpace}
        />
      ))}
    </Select>
  );
}
